import { RouteComponentProps, withRouter } from 'react-router-dom';

import { Sidebar } from './sidebar';

export interface SidebarProps extends RouteComponentProps {
    admin: boolean;
}

export default withRouter(Sidebar);